<life-di-nav></life-di-nav>
<lifedi-breadcrumb *ngIf="courseDetail" [lastPath]="courseDetail.COURSE_NAME"></lifedi-breadcrumb>

<div *ngIf="courseDetail" class="container">
  <div class="row">
    <h1 class="col-12" style="display: inline;">{{ courseDetail.COURSE_NAME }}
      <img *ngIf="!courseDetail.IS_FAVORITE" class="icon-header" src="../../../../assets/star-white.png" width="25px"
        height="25px" alt="Faverite" title="Faverite" (click)="changeFavorite(courseDetail.COURSE_ID)" />
      <img *ngIf="courseDetail.IS_FAVORITE" class="icon-header" src="../../../../assets/star.png" width="25px"
        height="25px" alt="Faverite" title="Faverite" (click)="changeFavorite(courseDetail.COURSE_ID)" />
      <img class="icon-header" src="../../../../assets/skill-tree.png" width="25px" height="25px" alt="Skill Tree"
        title="Skill Tree" (click)="getSkillTreeByCourse(courseDetail.COURSE_ID)" />
      <img *ngIf="progress < 100" class="icon-header" src="../../../../assets/certificate.png" width="25px"
        height="25px" style="filter: grayscale(100%);" alt="Certificate" title="Certificate" />
      <img *ngIf="progress === 100" class="icon-header" src="../../../../assets/certificate.png" width="25px"
        height="25px" alt="Certificate" title="Certificate" (click)="getCertificate()" />
    </h1>
  </div>

  <div *ngIf="reviews" class="row">
    <div class="col-xl-8 col-lg-6 col-md-12">
      <ng-template #r let-fill="fill">
        <span class="star" [class.full]="fill === 100">
          <span class="half" [style.width.%]="fill">&#x2605;</span>&#x2605;
        </span>
      </ng-template>
      <ngb-rating [(rate)]="reviews.POINT.AVERAGE_POINT" [starTemplate]="r" readonly="true"
        [max]="reviews.POINT.MAX_POINT">
      </ngb-rating>
      <span *ngIf="reviews.POINT.AVERAGE_POINT !== 0" style="margin-left: 10px; margin-top: 2px;">
        {{ reviews.POINT.AVERAGE_POINT | number:'1.1-1'}}/{{ reviews.POINT.MAX_POINT }}
        ({{ reviews.POINT.TOTAL_REVIEW }} รีวิว)
      </span>
      <span *ngIf="reviews.POINT.AVERAGE_POINT === 0" style="margin-left: 10px; margin-top: 2px;">
        {{ reviews.POINT.AVERAGE_POINT }}/{{ reviews.POINT.MAX_POINT }} ({{ reviews.POINT.TOTAL_REVIEW }} รีวิว)
      </span>
    </div>
    <div class="col-xl-4 col-lg-6 col-md-12">
      <div *ngIf="!courseDetail.IS_PROMISE" class="row text-center">
        <div [class.mt-3]="screenWidth < 992" class="col-12">

          <div *ngIf="courseDetail.IS_PREMIUM" style="width: 50%; padding: 7px; background: #fff; display: inline-block; border: 1px solid #DE5C8E;
          border-radius: 5px 0px 0px 5px;">
            <span *ngIf="courseDetail.COURSE_SPECIALPRICE === 0">ฟรี</span>
            <span *ngIf="courseDetail.COURSE_SPECIALPRICE !== 0">
              {{ courseDetail.COURSE_SPECIALPRICE | number }} บาท</span>
          </div>

          <div *ngIf="!courseDetail.IS_PREMIUM" style="width: 50%; padding: 7px; background: #fff; display: inline-block; border: 1px solid #DE5C8E;
          border-radius: 5px 0px 0px 5px;">
            <span *ngIf="courseDetail.COURSE_PRICE === 0">ฟรี</span>
            <span *ngIf="courseDetail.COURSE_PRICE !== 0">
              {{ courseDetail.COURSE_PRICE | number }} บาท
            </span>
          </div>
          <lifedi-btn *ngIf="!courseDetail.IS_LOGIN" (click)="openLogin()" lable="ซื้อคอร์ส" customStyle="background-color: #DE5C8E; color: #FFF; margin:0 !important; padding: 0 30px; width: 50%;
            border-radius: 0; border-radius: 0px 5px 5px 0px;">
          </lifedi-btn>
          <lifedi-btn *ngIf="courseDetail.IS_LOGIN" (click)="buyCourse()" lable="ซื้อคอร์ส" customStyle="background-color: #DE5C8E; color: #FFF; margin:0 !important; padding: 0 30px; width: 50%;
            border-radius: 0; border-radius: 0px 5px 5px 0px;">
          </lifedi-btn>
        </div>
      </div>
      <div *ngIf="courseDetail.IS_PROMISE && courseDetail.IS_LOGIN" class="row">
        <p class="col-12" style="width: 100%;">
          <ngb-progressbar [class.mt-3]="screenWidth < 992" [showValue]="true" type="success" [value]="this.progress"
            style="height: 1.5rem; font-size: 0.9rem; margin-bottom: -20px;"></ngb-progressbar>
        </p>
      </div>
    </div>
  </div>

  <div class="row mt-4 mb-4">
    <div class="col-xl-8 col-lg-12">
      <div *ngIf="urlVdoRender" class="vdo-frame">
        <iframe id="vdoFrame" [src]="urlVdoRender" frameborder="0" allowfullscreen></iframe>
      </div>
    </div>
    <div class="col-xl-4 col-lg-12">
      <div [class.panalHeight]="screenWidth >= 1200" [class.scroll]="screenWidth >= 1200"
        [class.mt-4]="screenWidth < 1200">
        <!-- {{screenWidth}} -->
        <mat-accordion>
          <mat-expansion-panel [expanded]="true" (opened)="panelOpenState = true" (closed)="panelOpenState = false">
            <mat-expansion-panel-header>
              <mat-panel-title>
                วิดีโอตัวอย่าง
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="topicLink">วิดีโอตัวอย่าง</div>
          </mat-expansion-panel>

          <mat-expansion-panel *ngFor="let c of courseDetail.DETAIL_COURSE; let i = index;"
            (opened)="panelOpenState = true" (closed)="panelOpenState = false">
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{ c.LESSON_NAME }}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <!-- check have doc -->
            <span *ngIf="c.LESSON_DOC && c.LESSON_DOC_ORIGINAL && courseDetail.IS_PROMISE">
              <div class="topicLink" (click)="getDoc(c.LESSON_DOC)">
                <img src="../../../../assets/docs.png" width="18px" height="18px">
                <span> &nbsp; {{ c.LESSON_DOC_ORIGINAL }} <small>[เอกสารประกอบการเรียน]</small></span>
              </div>
            </span>
            <span *ngIf="c.LESSON_DOC && c.LESSON_DOC_ORIGINAL && !courseDetail.IS_PROMISE">
              <div class="topicLink topicLinkDisable">
                <img src="../../../../assets/lock.png" width="18px" height="18px">
                <span> &nbsp; {{ c.LESSON_DOC_ORIGINAL }} <small>[เอกสารประกอบการเรียน]</small></span>
              </div>
            </span>
            <!-- paid -->
            <span *ngIf="courseDetail.IS_PROMISE">
              <div *ngFor="let t of c.DETAIL_COURSE; let j = index;" class="topicLink"
                (click)="getTopic(t.TOPIC_ID, t.TOPIC_TYPE, c.LESSON_ID, t.TOPIC_NAME)">
                <img *ngIf="t.TOPIC_TYPE === 'Video'" src="../../../../assets/video.png" width="18px" height="18px">
                <img *ngIf="t.TOPIC_TYPE === 'Quiz'" src="../../../../assets/quiz.png" width="18px" height="18px">
                <img *ngIf="t.TOPIC_TYPE === 'Assignment'" src="../../../../assets/assignment.png" width="18px"
                  height="18px">
                <img *ngIf="t.TOPIC_TYPE === 'Measure'" src="../../../../assets/test.png" width="18px" height="18px">
                <span> &nbsp; {{ t.TOPIC_NAME }} &nbsp; <small>[{{ t.TOPIC_TYPE }}]</small></span>
                <img *ngIf="topicComplete.DETAIL_COURSE[i].DETAIL_COURSE[j].TOPIC_COMPLETE"
                  src="../../../../assets/check.png" width="18px" height="18px" style="float: right; margin-top: 1px;">
              </div>
            </span>
            <!-- not paid -->
            <span *ngIf="!courseDetail.IS_PROMISE">
              <div *ngFor="let t of c.DETAIL_COURSE; let j = index;" class="topicLinkDisable">
                <img src="../../../../assets/lock.png" width="18px" height="18px" style="margin-top: -4px;">
                <span> &nbsp; {{ t.TOPIC_NAME }} <small>[{{ t.TOPIC_TYPE }}]</small></span>
              </div>
            </span>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <mat-tab-group (selectedTabChange)="onTabChanged($event)">
        <mat-tab label="เกี่ยวกับ">
          <div class="container">
            <div class="row">
              <div class="col-12 mt-4" id="_content" [innerHtml]="courseDes">
              </div>
            </div>
            <div class="row mt-4 mb-4">
              <div class="col-12">
                <hr width="100%">
              </div>
            </div>
            <div class="row justify-content-center">
              <div class="col-12">
                <h3 class="text-center">สอนโดย</h3>
                <div style="margin: 5px auto 0; width: fit-content;">
                  <img class="profilePic" [src]="courseDetail.TEACHER.PROFILE_PIC"><br />
                </div>
                <p class="text-center mt-4 mb-4" [innerHtml]="courseDetail.TEACHER.USERNAME"></p>
              </div>
            </div>
          </div>
        </mat-tab>

        <mat-tab label="รีวิว" *ngIf="courseDetail.OPEN_REVIEW === 'true'">
          <div class="container mb-4">
            <div *ngIf="reviews" class="row">
              <div class="col-12 mt-4 mb-3">
                <ng-template #t let-fill="fill">
                  <span class="star" [class.full]="fill === 100">
                    <span class="half" [style.width.%]="fill">&#x2605;</span>&#x2605;
                  </span>
                </ng-template>
                <ngb-rating class="removeBlueBg" [rate]="reviews.POINT.AVERAGE_POINT" [starTemplate]="t" readonly="true"
                  [max]="reviews.POINT.MAX_POINT">
                </ngb-rating>
                <span *ngIf="reviews.POINT.AVERAGE_POINT !== 0" style="margin-left: 10px; margin-top: 2px;">
                  {{ reviews.POINT.AVERAGE_POINT | number:'1.1-1'}}/{{ reviews.POINT.MAX_POINT }} ({{
                  reviews.POINT.TOTAL_REVIEW }} รีวิว)
                </span>

                <span *ngIf="reviews.POINT.AVERAGE_POINT === 0" style=" margin-left: 10px; margin-top: 2px;">
                  {{ reviews.POINT.AVERAGE_POINT }}/{{ reviews.POINT.MAX_POINT }} ({{ reviews.POINT.TOTAL_REVIEW }}
                  รีวิว)
                </span>
              </div>
            </div>
            <mat-card *ngIf="listReviews.length === 0 " class="row mb-3">
              <h3 class="col-12 text-center" style="margin: 16px 0; color: #ccc;">ยังไม่มีการเขียนรีวิว</h3>
            </mat-card>
            <!-- *ngIf="reviews?.REVIEW_LIST.length > 0"  -->

            <div *ngIf="listReviews.length > 0">
              <mat-card *ngFor="let r of listReviews" class="row mb-3" style="padding-top: 0;">
                <!-- mobile size -->
                <mat-card-content class="d-none d-block d-sm-block d-md-none" style="padding-bottom: 10px">
                  <div class="col-12 text-center inline-block mb-3">
                    <div style="margin: 5px 0 0; width: fit-content;">
                      <img width="50px" height="50px" style="border-radius: 50%; margin-top: 30px;"
                        [src]="r.IMAGE_PROFILE">
                      <div class="ml-3 text-left" style="display: inline-table;">
                        <ngb-rating class="mt-2 removeBlueBg" [(rate)]="r.REVIEW_POINT" readonly="true" max="5"
                          style="color: #ffc107;">
                        </ngb-rating>
                        <p>{{ r.USERNAME }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 inline-block">
                    {{ r.REVIEW_MESSAGE }}
                  </div>
                </mat-card-content>

                <!-- desktop size -->
                <mat-card-content style="padding-bottom: 10px"
                  class="d-none d-xl-block d-lg-block d-md-block d-lg-none d-xl-none d-xxl-none d-xxl-block">
                  <div class="col-lg-2 col-md-2 col-sm-3 col-4 text-center inline-block">
                    <div style="margin: 5px auto 0; width: fit-content;">
                      <img width="50px" height="50px" style="border-radius: 50%; margin-top: 30px;"
                        [src]="r.IMAGE_PROFILE"><br />
                      <ngb-rating class="mt-2 removeBlueBg" [(rate)]="r.REVIEW_POINT" readonly="true" max="5"
                        style="color: #ffc107;">
                      </ngb-rating><br>
                      <p>{{ r.USERNAME }}</p>
                    </div>
                  </div>
                  <div class="col-lg-10 col-md-10 col-sm-9 col-8 inline-block">
                    {{ r.REVIEW_MESSAGE }}
                  </div>
                </mat-card-content>
                <mat-card-footer style="position: absolute; right: 50px; bottom: 30px;">
                  {{ r.REVIEW_DATE | date }}
                </mat-card-footer>
              </mat-card>
            </div>

            <div *ngIf="isReviewMore" class="row justify-content-center">
              <a class="style-a" (click)="readReviewMore()">ดูรีวิวเพิ่มเติม</a>
            </div>

            <div *ngIf="courseDetail.IS_PROMISE && reviews?.CAN_POST" class="row mt-4">
              <h4>เขียนรีวิว</h4>
            </div>
            <form *ngIf="courseDetail.IS_PROMISE && reviews?.CAN_POST" [formGroup]="reviewForm" class="row">
              <div [ngStyle]="{'display': progress >= 80 ? 'none' : 'block' }" class="reviewBox">
                <h3 class="col-12">
                  <img src="../../../../assets/lock.png" width="45px" height="45px">
                  สามารถเขียนรีวิวได้เมื่อเรียนครบ 80%
                </h3>
              </div>
              <ngb-rating max="5" formControlName="rating" class="removeBlueBg"
                style="color: #ffc107; font-size: 25px; margin-bottom: 15px;">
              </ngb-rating>
              <textarea id="review" class="form-control" rows="6" formControlName="review"
                style="width: 98.5%; margin: 3px auto;"></textarea>
              <lifedi-btn *ngIf="reviewForm.valid" lable="ส่งรีวิว" (click)="confirmReview(reviewForm.value)"
                style="margin: 0 auto;"
                customStyle="background-color: #3E8C1A; color: #FFF; margin: 15px; padding: 0 30px;">
              </lifedi-btn>
              <lifedi-btn *ngIf="!reviewForm.valid" disabled="true" lable="ส่งรีวิว" style="margin: 0 auto;"
                customStyle="margin: 15px; padding: 0 30px;">
              </lifedi-btn>
            </form>
          </div>

          <div *ngIf="courseDetail.IS_PROMISE && !reviews?.CAN_POST" class="container">
            <mat-card class="row mt-4">
              <h3 class="col-12 text-center mt-2 mb-2" style="color: #ccc;">
                คุณได้รีวิวคอร์สเรียนแล้ว
              </h3>
            </mat-card>
          </div>
        </mat-tab>



        <mat-tab label="ห้องสนทนา" *ngIf="courseDetail.OPEN_CHAT === 'true'">
          <div *ngIf="courseDetail.IS_PROMISE" class="container">
            <mat-card *ngIf="listChat.length === 0 " class="row mt-4 mb-3">
              <h3 class="col-12 text-center" style="margin: 16px 0; color: #ccc;">ยังไม่มีการสนทนา</h3>
            </mat-card>
            <div *ngIf="listChat.length > 0" class="row">

              <!-- mobile size -->
              <mat-card *ngFor="let c of listChat; let i = index" [ngClass]="{'mt-3': i === 0}"
                class="col-12 mb-3 card-main d-none d-block d-sm-block d-md-none">
                <mat-card-content>
                  <div class="col-12 inline-block">
                    <div style="margin: 5px 0 10px; width: 100%; display: inline-flex;">
                      <img class="d-none d-block d-sm-block d-md-none" width="40px" height="40px"
                        style="border-radius: 50%;" [src]="c.PROFILE_PIC">
                      <div class="ml-3">
                        <span style="display: inline; line-height: 2.8;">{{ c.CHAT_USERNAME }}</span>
                        <div style="position: absolute; right: 15px; top: 4px;">
                          <span>ความคิดเห็นที่ {{ c.CHAT_NUMBER }}</span><br>
                          <small style="float: right;"> {{ c.CREATE_DATE | dateTime }} </small>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <div style="width: 100%;">
                      <mat-card class="col-12" style="background: #f6f6f6; border: 1px solid #ddd;">
                        {{ c.CHAT_MESSAGE }}
                      </mat-card>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false"
                        style="display: none;">reply
                      </mat-expansion-panel>
                      <div class="col-12">
                        <a class="style-a mt-2" style="float: right;" (click)="replyById(c.CHAT_NUMBER)">reply</a>
                      </div>
                    </div>
                  </div>
                </mat-card-content>
                <!-- <hr *ngIf="c?.SUB_CHAT.length > 0" width="80%"> -->
                <div class="row">
                  <mat-card *ngFor="let sc of c.SUB_CHAT; let j = index;" class="offset-1 col-11"
                    style="padding-top: 7px;">
                    <div class="col-12 inline-block">
                      <div style="margin: 5px 0 10px; width: fit-content;">
                        <img class="d-none d-block d-sm-block d-md-none" width="40px" height="40px"
                          style="border-radius: 50%;" [src]="sc.PROFILE_PIC">
                      </div>
                      <div class="ml-3">
                        <span style="display: inline;  line-height: 3.5;">{{ sc.CHAT_USERNAME }}</span>
                        <div style="position: absolute; right: 15px; top: 4px;">
                          <span>ความคิดเห็นที่ {{ sc.CHAT_NUMBER }}</span><br>
                          <small style="float: right;"> {{ sc.CREATE_DATE | dateTime }} </small>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 inline-block">
                      <div style="width: 100%; margin-top: 3px">
                        <mat-card style="background: #f6f6f6; border: 1px solid #ddd;">
                          {{ sc.CHAT_MESSAGE }}
                        </mat-card>
                      </div>
                    </div>
                  </mat-card>
                </div>
                <div class="row" style="margin-top: -5px;">
                  <mat-accordion class="col-12 text-center mt-2">
                    <mat-expansion-panel class="panelReply" [expanded]="panelOpenReply === c.CHAT_NUMBER"
                      hideToggle="true">
                      <form [id]="c.CHAT_ID" [formGroup]="subChatForm">
                        <div class="col-12">
                          <textarea id="chat" class="form-control" rows="4" formControlName="chat"
                            style="width: 100%; margin-top: 3px;"></textarea>
                        </div>
                        <lifedi-btn *ngIf="subChatForm.valid" lable="ส่ง"
                          (click)="confirmChat(subChatForm.value.chat, 'SUB', c.CHAT_ID)" style="margin: 0 auto;"
                          customStyle="background-color: #3E8C1A; color: #FFF; margin-top: 15px; padding: 0 30px;">
                        </lifedi-btn>
                        <lifedi-btn *ngIf="!subChatForm.valid" disabled="true" lable="ส่ง" style="margin: 0 auto;"
                          customStyle=" margin: 15px; padding: 0 30px;">
                        </lifedi-btn>
                      </form>
                    </mat-expansion-panel>
                  </mat-accordion>
                </div>
              </mat-card>

              <!-- desktop size -->
              <mat-card *ngFor="let c of listChat; let i = index" [ngClass]="{'mt-3': i === 0}"
                class="col-12 mb-3 card-main d-none d-xl-block d-lg-block d-md-block d-lg-none d-xl-none d-xxl-none d-xxl-block">
                <div class="row">
                  <div class="col-3 text-center">
                    <div style="margin: 5px auto 0; width: fit-content;">
                      <img class="d-none d-md-block d-lg-block d-xl-block" width="50px" height="50px"
                        style="border-radius: 50%; margin: 0 auto;" [src]="c.PROFILE_PIC">
                      <p class="mt-2">{{ c.CHAT_USERNAME }}</p>
                    </div>
                  </div>
                  <div class="col-8">
                    <div style="width: 100%;">
                      <p>ความคิดเห็นที่ {{ c.CHAT_NUMBER }}
                        <span class="d-none d-sm-none d-md-block" style="display: inline; float: right;">
                          {{ c.CREATE_DATE | dateTime }}
                        </span>
                      </p>
                      <mat-card class="col-12" style="background: #f6f6f6; border: 1px solid #ddd;">
                        {{ c.CHAT_MESSAGE }}
                      </mat-card>
                      <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                        reply</mat-expansion-panel>
                      <a class="style-a mt-2" style="float: right;" (click)="replyById(c.CHAT_NUMBER)">reply</a>
                    </div>
                  </div>
                </div>
                <hr *ngIf="c?.SUB_CHAT.length > 0" width="80%">
                <div class="row">
                  <mat-card *ngFor="let sc of c.SUB_CHAT; let j = index;" class="offset-1 col-10">
                    <div class="row">
                      <div class="col-3 text-center inline-block">
                        <div style="margin: 5px auto 0; width: fit-content;">
                          <img class="d-none d-md-block d-lg-block d-xl-block" width="50px" height="50px"
                            style="border-radius: 50%; margin: 0 auto;" [src]="sc.PROFILE_PIC">
                          <p class="mt-2">{{ sc.CHAT_USERNAME }}</p>
                        </div>
                      </div>
                      <div class="col-9 inline-block">
                        <div style="width: 100%;">
                          <p>ความคิดเห็นที่ {{ sc.CHAT_NUMBER }}
                            <span class="d-none d-sm-none d-md-block" style="display: inline; float: right;">
                              {{ sc.CREATE_DATE | dateTime }}
                            </span>
                          </p>
                          <mat-card style="background: #f6f6f6; border: 1px solid #ddd;">
                            {{ sc.CHAT_MESSAGE }}
                          </mat-card>
                        </div>
                      </div>
                    </div>
                  </mat-card>
                </div>
                <div class="row">
                  <mat-accordion class="offset-1 col-10 text-center mt-2">
                    <mat-expansion-panel class="panelReply" [expanded]="panelOpenReply === c.CHAT_NUMBER"
                      hideToggle="true">
                      <form [id]="c.CHAT_ID" [formGroup]="subChatForm">
                        <textarea id="chat" class="form-control" rows="4" formControlName="chat"
                          style="width: 98.5%; margin: 3px auto;"></textarea>
                        <lifedi-btn *ngIf="subChatForm.valid" lable="ส่ง"
                          (click)="confirmChat(subChatForm.value.chat, 'SUB', c.CHAT_ID)" style="margin: 0 auto;"
                          customStyle="background-color: #3E8C1A; color: #FFF; margin-top: 15px; padding: 0 30px;">
                        </lifedi-btn>
                        <lifedi-btn *ngIf="!subChatForm.valid" disabled="true" lable="ส่ง" style="margin: 0 auto;"
                          customStyle=" margin: 15px; padding: 0 30px;">
                        </lifedi-btn>
                      </form>
                    </mat-expansion-panel>
                  </mat-accordion>
                </div>
              </mat-card>
            </div>
            <div *ngIf="isChatMore" class="row justify-content-center">
              <a class="style-a" (click)="readChatMore()">ดูรีวิวเพิ่มเติม</a>
            </div>

            <hr class="mt-5 mb-5" width="100%">
            <div class="row">
              <h4>แสดงความคิดเห็น</h4>
            </div>
            <form [formGroup]="chatForm" class="row text-center">
              <textarea id="chat" class="form-control" rows="6" formControlName="chat"
                style="width: 98.5%; margin: 0 auto;"></textarea>
              <lifedi-btn *ngIf="chatForm.valid" lable="ส่ง" (click)="confirmChat(chatForm.value.chat, 'MAIN')"
                style="margin: 0 auto;"
                customStyle="background-color: #3E8C1A; color: #FFF; margin-top: 15px; padding: 0 30px;">
              </lifedi-btn>
              <lifedi-btn *ngIf="!chatForm.valid" disabled="true" lable="ส่ง" style="margin: 0 auto;"
                customStyle=" margin: 15px; padding: 0 30px;">
              </lifedi-btn>
            </form>
          </div>
          <div *ngIf="!courseDetail.IS_PROMISE" class="container">
            <div class="row mt-3 chatBox">
              <h3 class="col-12">
                <img src="../../../../assets/lock.png" width="45px" height="45px">
                ห้องสนทนาสามารถใช้ได้หลังจากลงทะเบียนเรียน
              </h3>
            </div>
          </div>
        </mat-tab>

        <mat-tab label="ข้อความส่วนตัว" *ngIf="courseDetail.OPEN_PRIVATECHAT === 'true' && courseDetail.IS_PROMISE">
          <!-- <mat-tab label="ข้อความส่วนตัว" *ngIf="courseDetail.OPEN_PRIVATECHAT === 'true' && courseDetail.IS_PROMISE"> -->
          <ng-template mat-tab-label>
            <span *ngIf="incomingMessage" matBadge="0" matBadgeOverlap="false" matBadgeColor="warn"
              class="hide-text">ข้อความส่วนตัว</span>
            <span *ngIf="!incomingMessage">ข้อความส่วนตัว</span>
          </ng-template>
          <div class="container">
            <mat-card *ngIf="privateMessage.length === 0 " class="row mt-4 mb-3">
              <h3 class="col-12 text-center" style="margin: 16px 0; color: #ccc;">ยังไม่มีการสนทนา</h3>
            </mat-card>
            <div *ngIf="privateMessage.length > 0" class="row d-flex">
              <div class="col-12">

                <div class="chatroom-container" #chatroom>
                  <div *ngFor="let c of privateMessage">
                    <div [ngClass]="c.USER_TYPE === 'user' ? 'chat-right' : 'chat-left'">
                      <div *ngIf="c.USER_TYPE === 'user'" class="chat-hour text-right">
                        {{ c.CREATE_DATE | dateTime:'time' }} น.<br>
                        {{ c.CREATE_DATE | dateTime:'shortNoTime' }}
                      </div>
                      <div class="chat-text-left"
                        [ngClass]="c.USER_TYPE === 'user' ? 'chat-text-right' : 'chat-text-left'">
                        <div *ngIf="c.MESSAGE_TYPE === 'text'">
                          {{ c.MESSAGE }}
                        </div>
                        <div *ngIf="c.MESSAGE_TYPE === 'image'">
                          <img nz-image class="image-attach" [nzSrc]="c.MESSAGE" alt="" />
                        </div>
                        <div *ngIf="c.MESSAGE_TYPE === 'file'">
                          <a (click)="downloadFile(c.MESSAGE)" class="text-center attach-file">
                            {{c.FILE_NAME}}
                            <img src="assets/attachment.png" alt="attach" style="width: 10px;">
                          </a>
                        </div>
                      </div>
                      <div *ngIf="c.USER_TYPE === 'admin'" class="chat-hour">
                        {{ c.CREATE_DATE | dateTime:'time' }} น.<br>
                        {{ c.CREATE_DATE | dateTime:'shortNoTime' }}
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <div class="row">
              <div class="col-12 mt-2">
                <nz-upload nzListType="picture-card"
                  nzAccept=".png, .jpg, .jpeg, .pdf, application/pdf, .csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  [(nzFileList)]="fileList" [nzShowButton]="fileList.length < 5" [nzCustomRequest]="successRequest"
                  (nzChange)="handleChange($event, privateChatForm)" [nzPreview]="handlePreview">
                  <!-- (nzChange)="compressFile($event)" [nzPreview]="handlePreview"> -->
                  <div>
                    <i nz-icon nzType="plus"></i>
                    <div style="margin-top: 8px">
                      <p>ลากไฟล์หรือคลิกเพื่ออัปโหลดไฟล์</p>
                      <p class="text-danger">สูงสุด 5 ไฟล์</p>
                    </div>
                  </div>
                </nz-upload>
                <nz-modal [nzVisible]="previewVisible" [nzContent]="modalContent" [nzFooter]="null"
                  (nzOnCancel)="previewVisible = false">
                  <ng-template #modalContent>
                    <img [src]="previewImage" [ngStyle]="{ width: '100%' }" />
                  </ng-template>
                </nz-modal>
              </div>
              <div class="col-12">
                <form [formGroup]="privateChatForm">
                  <textarea formControlName="message" class="form-control" id="object" rows="3" style="width: 100%;"
                    (ngModelChange)="getStatusSending($event)"></textarea>
                </form>
              </div>
            </div>
            <div class="row justify-content-center">
              <lifedi-btn *ngIf="sendTextStatus || sendImageStatus" lable="ส่ง"
                (click)="sendPrivateChat(privateChatForm)" style="margin: 0 auto;"
                customStyle="background-color: #3E8C1A; color: #FFF; margin: 15px; padding: 0 30px;">
              </lifedi-btn>
              <lifedi-btn *ngIf="!sendTextStatus && !sendImageStatus" disabled="true" lable="ส่ง"
                style="margin: 0 auto;" customStyle="margin: 15px; padding: 0 30px;">
              </lifedi-btn>
            </div>
          </div>

        </mat-tab>
      </mat-tab-group>
    </div>
  </div>

  <div class="row" [ngClass]="{'mt-1': courseDetail.COURSE_SUGGESTION.length === 0 }">&nbsp;</div>

  <h2 *ngIf="courseDetail.COURSE_SUGGESTION.length > 0" class="mt-4">คอร์สเรียนแนะนำ</h2>

  <!-- desktop size -->
  <div *ngIf="courseDetail.COURSE_SUGGESTION.length > 0 && courseDetail.COURSE_SUGGESTION.length >= 4"
    class="my-3 d-none d-xl-block d-lg-block d-md-block d-lg-none d-xl-none d-xxl-none d-xxl-block suggestBox">
    <div class="container mb-4">
      <owl-carousel-o [options]="customOptions">
        <ng-container *ngFor="let c of courseDetail.COURSE_SUGGESTION">
          <ng-template carouselSlide>
            <lifedi-course-card (click)="viewCourse(c.COURSE_ID)" [title]="c.COURSE_NAME" [haveFavorite]="false"
              [imageUrl]="c.COURSE_PIC" [teacherName]="c.USERNAME" [price]="c.COURSE_PRICE" style="outline: none;">
            </lifedi-course-card>
          </ng-template>
        </ng-container>
      </owl-carousel-o>
    </div>
  </div>

  <div *ngIf="courseDetail.COURSE_SUGGESTION.length > 0 && courseDetail.COURSE_SUGGESTION.length < 4"
    class="my-3 d-none d-xl-block d-lg-block d-md-block d-lg-none d-xl-none d-xxl-none d-xxl-block suggestBox">
    <div class="container mb-4">
      <div class="row">
        <div *ngFor="let c of courseDetail.COURSE_SUGGESTION" class="col-lg-3 col-md-4 col-sm-6 col-12 mb-4">
          <lifedi-course-card (click)="viewCourse(c.COURSE_ID)" [title]="c.COURSE_NAME" [haveFavorite]="false"
            [imageUrl]="c.COURSE_PIC" [teacherName]="c.USERNAME" [price]="c.COURSE_PRICE" style="outline: none;">
          </lifedi-course-card>
        </div>
      </div>
    </div>
  </div>
  <!-- desktop size -->

  <!-- mobile size -->
  <div *ngIf="courseDetail.COURSE_SUGGESTION.length > 0" class="my-3 d-none d-block d-sm-block d-md-none suggestBox-m">
    <div class="container mb-4">
      <owl-carousel-o [options]="customOptions">
        <ng-container *ngFor="let c of courseDetail.COURSE_SUGGESTION">
          <ng-template carouselSlide>
            <lifedi-course-card (click)="viewCourse(c.COURSE_ID)" [title]="c.COURSE_NAME" [haveFavorite]="false"
              [imageUrl]="c.COURSE_PIC" [teacherName]="c.USERNAME" [price]="c.COURSE_PRICE" style="outline: none;">
            </lifedi-course-card>
          </ng-template>
        </ng-container>
      </owl-carousel-o>
    </div>
  </div>
</div>
<!-- mobile size -->


<div *ngIf="isLoading">
  <div
    style="position: fixed; z-index: 900; width: 100vw; height: 100vh; opacity: 80; top: 0; left: 0; background: #e8e8e880;">
  </div>
  <mat-spinner class="spinner-center" style="z-index: 1000;"></mat-spinner>
</div>

<lifedi-footer *ngIf="courseDetail"></lifedi-footer>